var _g, _defs, _clipPath, _path, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "1230 1230 40 40",
    enableBackground: "new 1230 1230 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542c0.5-0.5,0.875-1.125,1.125-1.791 L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#0F9D58",
    d: "M1256.667,1230l13.333,40h-9.75c-1.417,0-2.667-0.583-3.583-1.542 c-0.5-0.5-0.875-1.125-1.125-1.791L1243.334,1230H1256.667z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542c0.5-0.5,0.875-1.125,1.125-1.791 L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -1383.7009,
    y1: 1969.5771,
    x2: -1382.801,
    y2: 1969.2826,
    gradientTransform: "matrix(26.0417 0 0 -26.0417 37285.1953 52537.1484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#263238",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#263238",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "url(#SVGID_5_)",
    d: "M1256.667,1230l-6.667,20l20,20L1256.667,1230z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_6_",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542c0.5-0.5,0.875-1.125,1.125-1.791 L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_7_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillOpacity: 0.24,
    d: "M1230,1270h0.208H1230z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#263238",
    enableBackground: "new    ",
    d: "M1230,1270l0.083-0.208L1230,1270z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1246.709,1253.167l-0.042,0.083"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542c0.5-0.5,0.875-1.125,1.125-1.791 L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_9_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F5",
    d: "M1243.334,1230L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542c0.5-0.5,0.875-1.125,1.125-1.791 l12.208-36.667H1243.334z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542 c0.5-0.5,0.875-1.125,1.125-1.791L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791 c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_11_)",
    fill: "#FFFFFF",
    fillOpacity: 0.2,
    d: "M1256.542,1230.208l0.125-0.208h-13.333L1230,1270 l0.125-0.208l13.208-39.583H1256.542z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_12_",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542 c0.5-0.5,0.875-1.125,1.125-1.791L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791 c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_13_)",
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M1244.459,1266.458 C1244.459,1266.5,1244.459,1266.5,1244.459,1266.458c-0.25,0.667-0.625,1.292-1.125,1.792c-0.917,0.917-2.167,1.542-3.583,1.542 h-9.625L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542c0.5-0.5,0.875-1.125,1.125-1.791l12.208-36.667l-0.125,0.208 L1244.459,1266.458z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_14_",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542 c0.5-0.5,0.875-1.125,1.125-1.791L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791 c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_15_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.1,
    d: "M1244.459,1266.708c-0.25,0.667-0.625,1.292-1.125,1.792 c-0.917,0.917-2.167,1.542-3.583,1.542l-9.667-0.042l-0.083,0.208h9.75c1.417,0,2.667-0.583,3.583-1.541 c0.5-0.5,0.875-1.125,1.125-1.792l12.25-36.792l-0.041-0.083L1244.459,1266.708z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542 c0.5-0.5,0.875-1.125,1.125-1.791L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791 c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_17_)",
    fill: "#263238",
    fillOpacity: 0.2,
    d: "M1269.917,1269.792l-13.25-39.792v0.208l13.208,39.583 h-9.667c-1.416,0-2.666-0.584-3.583-1.542c-0.5-0.5-0.875-1.125-1.125-1.792l0.083,0.209c0.25,0.666,0.625,1.291,1.125,1.791 c0.917,0.917,2.167,1.542,3.584,1.542H1270L1269.917,1269.792z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: -1384.011,
    cy: 1970.1934,
    r: 1.8431,
    gradientTransform: "matrix(26.0417 0 0 -26.0417 37285.1953 52537.1484)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M1256.667,1230h-13.333L1230,1270h9.75c1.417,0,2.667-0.583,3.583-1.542 c0.5-0.5,0.875-1.125,1.125-1.791L1250,1250l5.542,16.667c0.25,0.666,0.625,1.291,1.125,1.791 c0.916,0.917,2.166,1.542,3.583,1.542h9.75L1256.667,1230z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1230,1230h40v40h-40V1230z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDisplay);
export default __webpack_public_path__ + "static/media/logo-display.b333b6b8c3f249b632706666eebff8ae.svg";
export { ForwardRef as ReactComponent };